"use client";

import * as Dialog from "@radix-ui/react-dialog";
import type { ReactNode } from "react";
import { IconButton } from "./IconButton";
import { X } from "lucide-react";
import { cn } from "./cn";

export interface DrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  size?: "md" | "lg";
  footer?: ReactNode;
  children: ReactNode;
}

/** Secondary detail without losing the list behind it — closing preserves scroll/filters. */
export function Drawer({ open, onOpenChange, title, size = "md", footer, children }: DrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="ui-modal-overlay" />
        <Dialog.Content
          className={cn("ui-drawer-content", size === "lg" && "lg")}
          {...{ "aria-describedby": undefined }}
        >
          <div className="ui-drawer-header">
            <Dialog.Title asChild>
              <h2>{title}</h2>
            </Dialog.Title>
            <Dialog.Close asChild>
              <IconButton icon={<X size={18} />} label="Fechar" />
            </Dialog.Close>
          </div>
          <div className="ui-drawer-body">{children}</div>
          {footer ? <div className="ui-drawer-footer">{footer}</div> : null}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
